import React from 'react';

export const STATUS_META = {
  received: { label: 'Received', cls: 'bg-[hsl(var(--status-received))] text-[hsl(var(--status-received-fg))]' },
  estimate_sent: { label: 'Estimate sent', cls: 'bg-[hsl(var(--status-estimate-sent))] text-[hsl(var(--status-estimate-sent-fg))]' },
  approved: { label: 'Approved', cls: 'bg-[hsl(var(--status-approved))] text-[hsl(var(--status-approved-fg))]' },
  in_progress: { label: 'In progress', cls: 'bg-[hsl(var(--status-in-progress))] text-[hsl(var(--status-in-progress-fg))]' },
  ready: { label: 'Ready for release', cls: 'bg-[hsl(var(--status-ready))] text-[hsl(var(--status-ready-fg))]' },
  closed: { label: 'Paid & released', cls: 'bg-[hsl(var(--status-closed))] text-[hsl(var(--status-closed-fg))]' },
  voided: { label: 'Voided', cls: 'bg-[hsl(var(--status-voided))] text-[hsl(var(--status-voided-fg))]' },
};

export const StatusPill = ({ status }) => {
  const meta = STATUS_META[status] || { label: status, cls: 'bg-gray-100 text-gray-700' };
  return (
    <span
      data-testid="status-pill"
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium border border-black/5 whitespace-nowrap ${meta.cls}`}
    >
      {meta.label}
    </span>
  );
};
